export const API_URL = "https://staticblogr20230403213339.azurewebsites.net";
